import { isBaseDomainHost } from '@/lib/request-host';

/**
 * Portals are subdomains of the visitor's host (`www.localhost:3001` -> `correos.localhost:3001`). On
 * the apex or a bare dev host the label goes in front; replacing the first label there points every
 * portal link at a domain we don't own (TEC-3910).
 */
export function buildPortalHref(baseUrl: string, portalId: string): string {
	let url: URL;
	try {
		url = new URL(baseUrl);
	} catch {
		// Before the dehydrated context lands: wrong, but inert rather than somebody else's domain.
		return `/${portalId}`;
	}

	const labels = url.hostname.replace(/\.$/, '').split('.');
	const rest = isBaseDomainHost(url.hostname) ? labels : labels.slice(1);

	url.hostname = [portalId, ...rest].join('.');
	return url.origin;
}

/** No `/{portalId}` segment: on a portal host the campaign lives at the root. */
export function buildCampaignHref(baseUrl: string, portalId: string, slug: string): string {
	return `${buildPortalHref(baseUrl, portalId)}/${slug}`;
}
